import { Component, Input } from '@angular/core';

interface ContactableUser {
  email?: string;
  mobileNumber?: string;
}

@Component({
  selector: 'vnm-user-contacts',
  templateUrl: './user-contacts.component.html',
  styleUrls: ['./user-contacts.component.scss']
})
export class UserContactsComponent {
  @Input() user: ContactableUser;
  @Input() enableLinks = true;
  @Input() showIcons = true;
}
